import { apiFetch } from "~/lib/fetchClient";

// UPDATE TINYMCE_SCRIPT_PATH and cache_suffix when updating tinymce
export const TINYMCE_SCRIPT_PATH = "/packs/dist/tinymce/tinymce.min.js?v=7.9.1";
export const TINYMCE_SCROLLABLE_UI_OPTIONS = {
  // Keep TinyMCE menus anchored to editors inside scrollable page containers.
  ui_mode: "split",
};

export const SIGNATURE_EDITOR_PLUGINS =
  "autoresize code advlist lists preview emoticons link autolink image wordcount table visualblocks charmap media";
export const SIGNATURE_EDITOR_TOOLBAR =
  "undo redo | blocks fontfamily fontsize | bold italic underline | alignleft aligncenter alignright alignjustify | outdent indent | numlist bullist | image videos link table | charmap emoticons | forecolor backcolor | removeformat | preview | ai-assist | code";

export const LANDING_PAGE_EDITOR_PLUGINS =
  "autoresize code advlist lists preview emoticons link autolink image wordcount table visualblocks charmap media";
export const LANDING_PAGE_EDITOR_TOOLBAR =
  "undo redo | blocks fontfamily fontsize | bold italic underline | alignleft aligncenter alignright alignjustify | outdent indent | numlist bullist | image videos media link table | charmap emoticons | forecolor backcolor | removeformat | preview | ai-assist | code";

export const ACTIVITY_EDITOR_PLUGINS =
  "autoresize advlist lists preview emoticons link autolink image wordcount table charmap";
export const ACTIVITY_EDITOR_TOOLBAR =
  "undo redo | blocks fontfamily fontsize | bold italic underline | alignleft aligncenter alignright alignjustify | outdent indent | numlist bullist | image link table | charmap emoticons | forecolor backcolor | removeformat | preview | ai-assist";
export const ACTIVITY_VARIABLE_EDITOR_TOOLBAR =
  "undo redo | blocks fontfamily fontsize | bold italic underline | alignleft aligncenter alignright alignjustify | outdent indent | numlist bullist | image link table | charmap emoticons | forecolor backcolor | variables | removeformat | preview | ai-assist";

export const APPT_EDITOR_PLUGINS =
  "autoresize preview emoticons wordcount charmap advlist lists link autolink";
export const APPT_EDITOR_TOOLBAR =
  "undo redo | bold italic | numlist bullist | link | charmap emoticons | variables | removeformat | preview | ai-assist";

export const TASK_EDITOR_PLUGINS =
  "autoresize advlist lists preview emoticons link charmap";
export const TASK_EDITOR_TOOLBAR =
  "undo redo | bold italic underline | numlist bullist | link | charmap emoticons | forecolor backcolor | variables | preview | ai-assist";
export const TASK_CAMPAIGN_EDITOR_TOOLBAR =
  "undo redo | bold italic underline | numlist bullist | link | charmap emoticons | forecolor backcolor | variables | preview | ai-assist";
export const TASK_EDITOR_TOOLBAR_WITHOUT_VARIABLES =
  "undo redo | bold italic underline | numlist bullist | link | charmap emoticons | forecolor backcolor | preview | ai-assist";

export const EMAIL_EDITOR_PLUGINS =
  "autoresize code advlist lists preview emoticons link autolink image wordcount table visualblocks charmap";
export const EMAIL_EDITOR_TOOLBAR =
  "undo redo | blocks fontfamily fontsize | bold italic underline | alignleft aligncenter alignright alignjustify | outdent indent | numlist bullist | image videos link table | charmap emoticons | forecolor backcolor | variables | removeformat | preview | code | ai-assist";

export const EMAIL_QUOTE_STYLES = `
  /* Collapsed state */
  .ss-email-thread__quote--collapsed {
    display: none;
  }

  /* Toggle button wrapper */
  .ss-email-thread__toggle-wrapper {
    position: absolute;
    bottom: 10px;
    left: 10px;
    z-index: 100;
  }
`;

export const formatEmailReplyBody = ({
  body,
  senderName,
  senderEmail,
  createdAt,
}) => {
  const date = new Date(createdAt);
  const formattedDate = date.toLocaleString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });

  const quoteHeader = `On ${formattedDate} ${senderName} &lt;${senderEmail}&gt; wrote:`;

  return `
    <div></div>
    <div class="ss-email-thread" style="margin:5px 0 0;padding:5px 0 0;">
      <div class="ss-email-thread__quote ss-email-thread__quote--collapsed" style="margin:0;">
        <div>${quoteHeader}</div>
        <blockquote style="margin:0!important;padding-left:12px!important;border-left:1px solid#ddd!important;">
          <div>${body}</div>
        </blockquote>
      </div>
    </div>
  `;
};

export const SMS_TEXT_EDITOR_PLUGINS =
  "autoresize preview emoticons wordcount charmap";
export const SMS_TEXT_EDITOR_TOOLBAR =
  "undo redo | charmap emoticons | images videos | variables | preview | ai-assist";

export const JOB_DESCRIPTION_EDITOR_PLUGINS =
  "autoresize code advlist lists preview emoticons link autolink image wordcount table visualblocks charmap";
export const JOB_DESCRIPTION_EDITOR_TOOLBAR =
  "undo redo | blocks fontfamily fontsize | bold italic underline | alignleft aligncenter alignright alignjustify | outdent indent | numlist bullist | image videos link table | charmap emoticons | forecolor backcolor | removeformat | preview | code | ai-assist";

export const IMAGES_UPLOAD_HANDLER = (blobInfo, progress) => {
  const formData = new FormData();
  formData.append("image[image]", blobInfo.blob(), blobInfo.filename());

  const { promise } = apiFetch.upload("/images", {
    body: formData,
    onProgress: (pct) => progress(pct),
  });

  return promise
    .then((data) => {
      if (data?.image?.url) {
        return data.image.url;
      }
      throw new Error("Invalid response, URL missing.");
    })
    .catch((err) => {
      throw { message: err?.message || "Image upload failed", remove: true };
    });
};
